import paths from "@ingka/icons-shared/paths/cross-small";
import { renderPaths } from "../renderPaths.mjs";
var cross_small_default = () => renderPaths(paths);
export {
  cross_small_default as default
};
